<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-add-contributions">
  <div class="org-admin-add-contributions--layout">
    <app-org-admin-sidebar class="org-admin-add-contributions--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-add-contributions--content">
      <app-page-header></app-page-header>
      <div class="add-contributions-container">
        <!-- Content will be added here -->
      </div>
    </div>
  </div>
</div>



